import React from 'react';
import {useTranslations} from 'next-intl';
import {Field} from 'redux-form';
import Typography from '@material-ui/core/Typography';
import {Spacing} from '../Styles';
import TextField from '../Input/TextField';
import RadioButton from '../Input/RadioButton';
import Checkbox from '../Input/Checkbox';
import PhoneNumber from '../Input/PhoneNumber';
import SelectCountry from '../Input/SelectCountry';
import DateField from '../Input/DateField';
import {required as validateRequired} from '../../libs/validation';

const helpOrNone = help => {
    if (!help) return;
    help = help.trim();
    if (help.length > 1) {
        return help;
    }
};

const renderCustomFieldsArray = ({fields, customFields}) => {
    const t = useTranslations('components.CustomField');
    return fields.map((field, i) => {
        const {type, name, help, required, choices} = customFields[i];
        let fieldProps = {
            component: TextField,
            helperText: helpOrNone(help),
        };

        // disable autocomplete and autofill
        if (['text', 'textarea', 'date', 'phone', 'email'].includes(type)) {
            fieldProps.inputProps = {
                ...field.inputProps,
                autoComplete: 'new-password',
            };
        }

        if (type === 'textarea') {
            fieldProps.multiline = true;
            fieldProps.rows = 4;
        }

        if (['text', 'textarea'].includes(type)) {
            fieldProps.variant = 'outlined';
            fieldProps.fullWidth = true;
        }

        if (type === 'radio') {
            fieldProps.component = RadioButton;
            fieldProps.labelsAndValuesList = [
                {label: t('Yes'), value: 'yes'},
                {label: t('No'), value: 'no'},
            ];
        }

        if (['multichoice', 'checkbox'].includes(type)) {
            fieldProps.component = (type === 'checkbox') ? Checkbox : RadioButton;
            fieldProps.labelsAndValuesList = choices.map(option => ({
                label: option.label || option.text,
                value: option.value || option.text
            }));
        }

        if (type === 'date') {
            // fieldProps.type = 'date';
            fieldProps.type = 'text';
            fieldProps.component = DateField;
            fieldProps.fullWidth = true;
        }

        if (type === 'phone') {
            fieldProps.type = 'text';
            fieldProps.component = PhoneNumber;
            fieldProps.fullWidth = true;
        }

        if (type === 'email') {
            fieldProps.type = 'text';
            fieldProps.fullWidth = true;
        }

        if (type === 'country') {
            fieldProps.type = 'text';
            fieldProps.component = SelectCountry;
            fieldProps.fullWidth = true;
        }

        if (['true', 'yes', '1', 1, true].includes(required)) {
            fieldProps.validate = validateRequired;
        }

        return (
            <React.Fragment key={`custom-field-${name}`}>
                <Typography
                    variant="h5"
                    gutterBottom
                >
                    {name}
                </Typography>
                <Field
                    type="hidden"
                    name={`${field}.question`}
                    value={name}
                    style={{display: 'none'}}
                    component={TextField}
                />
                <Field
                    name={`${field}.answer`}
                    {...fieldProps}
                />
                <Spacing/>
            </React.Fragment>
        );
    });

};

export default renderCustomFieldsArray;